import React from "react";
import { Chrono } from "react-chrono";
import dayjs from "dayjs";

export const TaskLogs: React.FC<{ logs: any[] }> = ({ logs }) => {
    if (!logs || logs.length === 0) {
        return <p className="text-sm text-slate-500 py-4">No logs found</p>;
    }

    const items = logs
        .map((x) => ({
            cardTitle: x["op"] || "Operation",
            cardSubtitle: dayjs(x["when"]).format("MMMM Do YYYY, h:mm:ss a"),
            cardDetailedText: x["who"]?.name || "",
        }))
        .reverse();

    return (
        <div className="max-h-96 overflow-y-auto">
            <Chrono items={items} mode="VERTICAL" cardHeight={80} />
        </div>
    );
};
